import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export type DetailTab = 'details' | 'rules' | 'data-banks';

@Component({
  selector: 'app-challenge-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './challenge-tabs.component.html',
  styleUrl: './challenge-tabs.component.scss'
})
export class ChallengeTabsComponent {
  @Input() activeTab: DetailTab = 'details';
  @Output() tabChange = new EventEmitter<DetailTab>();

  setTab(tab: DetailTab): void {
    this.tabChange.emit(tab);
  }
}


